export const styles = {
  popoverContent: (theme) => ({
    backgroundColor: theme.palette.background.default,
    maxHeight: 300,
    overflow: "auto",
  }),
  popover: {
    zIndex: 9999999,
  },
  avatar: (theme) => ({
    bgcolor: theme.palette.background.default,
    mr: "0px!important",
    width: 24,
    height: 24,
    fontSize: 12,
    "&:hover": {
      bgcolor: theme.palette.background.default,
    },
  }),
  translatorBtn: (theme) => ({
    bgcolor: theme.palette.background.default,
    "&:hover": {
      bgcolor: theme.palette.background.default,
    },
  }),
  select: (theme) => ({
    border: `1px solid ${theme.palette.grey.lighter1}`,
    width: "100%",
    minWidth: 120,
    backgroundColor: theme.palette.background.default,
    px: 1,
  }),
  toolTip: (theme) => ({
    backgroundColor: theme.palette.background.default,
  }),
  language: (theme) => ({
    fontSize: 12,
    py: 0.625,
    color: theme.palette.primary.main,
  }),
  translationText: {
    // py: 0.625
  },
  content: {
    minWidth: 200,
    maxWidth: 300,
  },
  divider: {
    height: 10,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 10,
    p: 0,
  },
  translatorTypoContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  moreItem: (theme) => ({
    borderBottom: `2px solid ${theme.palette.hover.main}`,
  }),
  more: {
    fontSize: 12,
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-end",
  },
  clickable: {
    cursor: "pointer",
  },
}
